import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import fetchBase from "../utils/fetchBase";
import SignaturePad from "../components/SignaturePad";
import "./MyPassedShifts.css";

const STATUS_LABELS = {
    SCHEDULED: { label: "Scheduled", color: "#0071e3" },
    MISSED: { label: "Needs Veteran Initial", color: "#ff9500" },
    IN_PROGRESS: { label: "In Progress", color: "#ff9500" },
    AWAITING_VETERAN_SIGNATURE: { label: "Awaiting Veteran Signature", color: "#ff9500" },
    COMPLETED: { label: "Completed", color: "#34c759" },
};

const formatPeriodDate = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-").map(Number);
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString(undefined, { month: "long", day: "numeric" });
};

const buildPeriodCalendar = (startDateStr, endDateStr) => {
    if (!startDateStr || !endDateStr) return [];
    const [sy, sm, sd] = startDateStr.split("-").map(Number);
    const [ey, em, ed] = endDateStr.split("-").map(Number);
    const start = new Date(sy, sm - 1, sd);
    const end = new Date(ey, em - 1, ed);

    const leadingBlanks = start.getDay();
    const days = [];
    for (let i = 0; i < leadingBlanks; i++) {
        days.push(null);
    }

    const cursor = new Date(start);
    while (cursor <= end) {
        const dateStr = `${cursor.getFullYear()}-${String(cursor.getMonth() + 1).padStart(2, "0")}-${String(cursor.getDate()).padStart(2, "0")}`;
        days.push({ day: cursor.getDate(), dateStr });
        cursor.setDate(cursor.getDate() + 1);
    }
    return days;
};

const MyPassedShifts = () => {
    const navigate = useNavigate();
    const [menuOpen, setMenuOpen] = useState(false);
    const [unreadCount, setUnreadCount] = useState(0);
    const [periods, setPeriods] = useState([]);
    const [selectedPeriodId, setSelectedPeriodId] = useState(null);
    const [shifts, setShifts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const shiftTileRefs = React.useRef({});
    const [pendingInitialScheduleId, setPendingInitialScheduleId] = useState(null);

    const scrollToShift = (dateStr) => {
        const el = shiftTileRefs.current[dateStr];
        if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "center" });
            el.style.transition = "background 0.3s";
            el.style.background = "#eef6ff";
            setTimeout(() => { el.style.background = ""; }, 1200);
        }
    };

    const handleSaveVeteranInitial = async (dataUrl) => {
        const token = localStorage.getItem("jwt_token");
        try {
            const res = await fetch(`${fetchBase}/time-log/schedule/${pendingInitialScheduleId}/veteran-initial`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({ veteranInitial: dataUrl })
            });

            if (res.ok) {
                setShifts(prev => prev.map(s =>
                    s.scheduleId === pendingInitialScheduleId ? { ...s, status: "COMPLETED" } : s
                ));
            } else {
                console.error("Failed to save veteran initial");
            }
        } catch (err) {
            console.error("Error saving veteran initial:", err);
        } finally {
            setPendingInitialScheduleId(null);
        }
    };





        useEffect(() => {
            const authHeader = "Bearer " + localStorage.getItem("jwt_token");
            fetch(`${fetchBase}/api/notifications/unread-count`, {
                headers: { Authorization: authHeader }
            })
                .then(res => res.json())
                .then(data => {
                    if (data && typeof data.count === "number") setUnreadCount(data.count);
                })
                .catch(err => console.error("Failed to fetch unread count:", err));
        }, []);

        useEffect(() => {
            const fetchPeriods = async () => {
            try {
                const phone = localStorage.getItem("employee_phone");
                const token = localStorage.getItem("jwt_token");

                if (!phone || !token) {
                    setError("Missing authentication data.");
                    setLoading(false);
                    return;
                }

                const response = await fetch(
                    `${fetchBase}/time-log/my-pay-periods?phone=${encodeURIComponent(phone)}`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );

                if (!response.ok) throw new Error("Failed to fetch pay periods.");

                const data = await response.json();
                setPeriods(Array.isArray(data) ? data : []);

                const active = data.find(p => p.status === "ACTIVE");
                setSelectedPeriodId(active ? active.payPeriodId : (data[0]?.payPeriodId ?? null));
            } catch (err) {
                console.error("Error fetching pay periods:", err);
                setError("Unable to load pay periods.");
                setLoading(false);
            }
        };

        fetchPeriods();
    }, []);

    useEffect(() => {
        if (!selectedPeriodId) return;

        const fetchShifts = async () => {
            setLoading(true);
            try {
                const phone = localStorage.getItem("employee_phone");
                const token = localStorage.getItem("jwt_token");

                const response = await fetch(
                    `${fetchBase}/time-log/period-shifts?phone=${encodeURIComponent(phone)}&payPeriodId=${selectedPeriodId}`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );

                if (!response.ok) throw new Error("Failed to fetch shifts.");

                const data = await response.json();
                setShifts(Array.isArray(data) ? data : []);
            } catch (err) {
                console.error("Error fetching shifts:", err);
                setError("Unable to load shift history.");
            } finally {
                setLoading(false);
            }
        };

        fetchShifts();
    }, [selectedPeriodId]);

    const currentIndex = periods.findIndex(p => String(p.payPeriodId) === String(selectedPeriodId));

    const goToPrevious = () => {
        if (currentIndex < periods.length - 1) {
            setSelectedPeriodId(periods[currentIndex + 1].payPeriodId);
        }
    };

    const goToNext = () => {
        if (currentIndex > 0) {
            setSelectedPeriodId(periods[currentIndex - 1].payPeriodId);
        }
    };

            const selectedPeriod = periods.find(p => String(p.payPeriodId) === String(selectedPeriodId));

            console.log("DEBUG selectedPeriodId:", selectedPeriodId);
            console.log("DEBUG periods:", periods);
            console.log("DEBUG selectedPeriod:", selectedPeriod);
            console.log("DEBUG currentIndex:", currentIndex);

            const shiftsByDate = {};
            shifts.forEach(s => { shiftsByDate[s.date] = s; });

            const calendarDays = selectedPeriod
                ? buildPeriodCalendar(selectedPeriod.startDate, selectedPeriod.endDate)
                : [];

            const dayLabels = ["S", "M", "T", "W", "T", "F", "S"];

            if (error) {
        return (
            <div className="history-container">
                <p className="error-text">{error}</p>
            </div>
        );
    }

        return (
            <>
                <nav className="apple-global-nav">

                    <div className="left-nav">
                        <img src="/images/logoPlaceholder1.png" alt="Logo" className="apple-logo"/>
                    </div>

                    <div className="center-nav">
                        <a href="/employee/dashboard">Dashboard</a>
                    </div>

                    <div className="notification-bell-container" style={{ position: "relative", marginRight: "16px", cursor: "pointer" }} onClick={() => navigate("/employee/notifications")}>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6e6e73" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
                            <path d="M13.73 21a2 2 0 0 1-3.46 0" />
                        </svg>
                        {unreadCount > 0 && (
                            <span style={{
                                position: "absolute", top: "-6px", right: "-8px",
                                background: "#ff3b30", color: "white", fontSize: "10px",
                                fontWeight: "700", borderRadius: "10px", padding: "1px 5px",
                                minWidth: "14px", textAlign: "center"
                            }}>
                                {unreadCount}
                            </span>
                        )}
                    </div>

                    <div className="account-dropdown-container">
                        <span className="account-link">Account ▾</span>
                        <div className="account-dropdown">
                            <a href="/employee/history">History</a>
                            <a href="/employee/manual">Manual</a>
                            <a href="/logout">Log Out</a>
                        </div>
                    </div>

                    <button
                        className={`hamburger-btn ${menuOpen ? "open" : ""}`}
                        onClick={() => setMenuOpen(!menuOpen)}
                    >
                        <span className="bar"></span>
                        <span className="bar"></span>
                    </button>

                </nav>

                {menuOpen && (
                    <div className="admin-mobile-menu">
                        <a href="/employee/dashboard" onClick={() => setMenuOpen(false)}>Dashboard</a>
                        <a href="/employee/history" onClick={() => setMenuOpen(false)}>History</a>
                        <a href="/employee/document-hub" onClick={() => setMenuOpen(false)}>Document Hub</a>
                        <a href="/employee/timesheets" onClick={() => setMenuOpen(false)}>Timesheets</a>
                        <a href="/employee/manual" onClick={() => setMenuOpen(false)}>Manual</a>
                        <a href="/logout" onClick={() => setMenuOpen(false)}>Log Out</a>
                    </div>
                )}

            <div className="history-container">
                <h2>My Shift History</h2>

            {selectedPeriod && (
                <div className="period-selector">
                    <button onClick={goToPrevious} disabled={currentIndex >= periods.length - 1}>
                        ‹
                    </button>
                        <span className="period-label">
                            {formatPeriodDate(selectedPeriod.startDate)} to {formatPeriodDate(selectedPeriod.endDate)}
                            {selectedPeriod.status === "ACTIVE" && " (Current)"}
                            {selectedPeriod.status === "NEXT" && " (Upcoming)"}
                        </span>
                    <button onClick={goToNext} disabled={currentIndex <= 0}>
                        ›
                    </button>
                </div>
            )}

                {!loading && calendarDays.length > 0 && (
                    <div style={{ marginBottom: "20px" }}>
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: "4px", marginBottom: "6px" }}>
                            {dayLabels.map((d, i) => (
                                <div key={i} style={{ textAlign: "center", fontSize: "11px", color: "#a0a0a0" }}>{d}</div>
                            ))}
                        </div>
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: "4px" }}>
                            {calendarDays.map((d, i) => {
                                if (!d) return <div key={i} />;
                                const shift = shiftsByDate[d.dateStr];
                                const statusInfo = shift ? (STATUS_LABELS[shift.status] || { color: "#e0e0e0" }) : null;
                                return (
                                    <div
                                        key={i}
                                        onClick={() => shift && scrollToShift(d.dateStr)}
                                        style={{
                                            aspectRatio: "1",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            fontSize: "13px",
                                            fontWeight: shift ? 600 : 400,
                                            borderRadius: "8px",
                                            cursor: shift ? "pointer" : "default",
                                            background: statusInfo ? statusInfo.color + "26" : "transparent",
                                            color: statusInfo ? statusInfo.color : "#a0a0a0",
                                        }}
                                    >
                                        {d.day}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}

                {loading ? (
                    <p>Loading shift history...</p>
                ) : shifts.length === 0 ? (
                    <p>No shifts found for this pay period.</p>
                ) : (
                    shifts.map((shift, idx) => {
                        const statusInfo = STATUS_LABELS[shift.status] || { label: shift.status, color: "#6e6e73" };
                        const isMissed = shift.status === "MISSED";
                        return (
                            <div
                                key={idx}
                                className="history-tile"
                                ref={(el) => { shiftTileRefs.current[shift.date] = el; }}
                                onClick={() => isMissed && setPendingInitialScheduleId(shift.scheduleId)}
                                style={isMissed ? { cursor: "pointer" } : {}}
                            >
                            <div className="history-date">{shift.date}</div>
                            <div className="history-client">{shift.clientName || "Unknown Client"}</div>
                            <div className="history-time">
                                {shift.startTime} → {shift.endTime}
                            </div>
                            <div className="history-hours">
                                {shift.shiftHours != null ? `${shift.shiftHours} hrs` : "--"}
                            </div>
                            <div className="history-status" style={{ color: statusInfo.color, fontWeight: 600, fontSize: "12px" }}>
                                {statusInfo.label}
                            </div>
                            </div>
                        );
                    })
                )}

                {pendingInitialScheduleId && (
                    <SignaturePad
                        label="Veteran Initial"
                        onSave={handleSaveVeteranInitial}
                        note="This shift was added after it occurred. The scheduled start and end time will be recorded."
                    />
                )}
                    </div>
                    </>
                );
            };

        export default MyPassedShifts;